import { CustomButton } from "@/components/ui/Buttons";
import AiTokenIcon from "@/assets/icons/AiToken.svg";
import { formatPrice } from "../aiPricing";

const PurchaseAiToken = ({
  isLoading,
  symbol,
  onTopupPurchase,
}: {
  isLoading: string;
  symbol: string;
  onTopupPurchase: () => void;
}) => {
  return (
    <div className="mx-auto max-w-[820px] rounded-2xl border border-[#F1F2F9] bg-white ai-pricing-card-shadow">
      <div className="p-5 flex flex-col items-center justify-between gap-4 sm:flex-row px-7 py-[24.5px]">
        <div className="space-y-1">
          <h2 className="text-[24px] font-medium text-[#060B13] tracking-[-1%]">
            Need more <span className="text-[#FF6600]">Tokens</span>?
            <span className="italic"> Top up anytime.</span>
          </h2>
          <p className="text-base text-[#363D4F]">
            Add-ons apply instantly and don’t change your plan.
          </p>
        </div>

        <div className="space-y-3 bg-[#FAFAFA] rounded-[12px] border border-[#F0F0F0] p-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-x-1">
              <AiTokenIcon />
              <p className="text-[16px] font-semibold">10 Tokens</p>
            </div>
            <p className="text-[#FF6600] text-[16px] font-medium font-grotesk">
              @
            </p>
            <div className="flex items-center gap-x-2">
              <p className="text-2xl leading-[115%] tracking-normal font-medium text-[#170F49] font-grotesk">
                {formatPrice(12, symbol)}
              </p>
            </div>
          </div>
          <CustomButton
            variant="outline"
            padding="8px"
            color="#170F49"
            border="1px solid #FF6600"
            fontSize="16px"
            fontWeight="500"
            className="w-full"
            onClick={onTopupPurchase}
            disabled={!!isLoading}
            aria-busy={isLoading === "topup_10"}
          >
            {isLoading === "topup_10" ? "Processing..." : "Buy 10 Tokens"}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default PurchaseAiToken;
